import { Star, ExternalLink } from "lucide-react";
import { Reveal, SectionHead } from "./Shared";

export default function Reviews({ reviews, locations }) {
  return (
    <section id="resenas" data-testid="reviews-section" className="bg-secondary/50 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHead
          num="05"
          testid="reviews-title"
          title="Lo que dicen nuestros clientes"
          sub="Reseñas reales de Google de nuestras dos sucursales en San Pedro Sula."
        />
        {reviews.length > 0 ? (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-testid="reviews-grid">
            {reviews.map((r, i) => (
              <Reveal key={r.id || i} delay={Math.min(i * 0.08, 0.3)} className="flex flex-col border border-border bg-white p-7">
                <div className="flex items-center gap-1">
                  {[...Array(Math.max(1, Math.min(5, Number(r.rating) || 5)))].map((_, j) => (
                    <Star key={j} className="h-4 w-4 fill-amber-400 text-amber-400" />
                  ))}
                </div>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground/90">“{r.text}”</p>
                <div className="mt-5 border-t border-border pt-4">
                  <p className="text-sm font-extrabold text-primary">{r.author}</p>
                  <p className="text-xs text-muted-foreground">
                    {[r.location, r.date].filter(Boolean).join(" · ") || "Reseña de Google"}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        ) : (
          <Reveal className="border border-border bg-white p-8 md:p-12" data-testid="reviews-google-panel">
            <div className="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
              <div className="max-w-xl">
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />
                  ))}
                </div>
                <p className="mt-4 text-base leading-relaxed text-muted-foreground">
                  Mira lo que dicen directamente en los perfiles de nuestras sucursales.
                </p>
              </div>
              <div className="flex flex-col gap-3">
                {locations.map((loc, i) => (
                  <a
                    key={loc.id || i}
                    data-testid={`reviews-google-link-${i}`}
                    href={loc.maps_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-12 items-center justify-center gap-2 border-2 border-primary px-6 text-sm font-semibold text-primary transition-colors duration-300 hover:bg-primary hover:text-white"
                  >
                    <ExternalLink className="h-4 w-4" /> Ver reseñas — {loc.name}
                  </a>
                ))}
              </div>
            </div>
          </Reveal>
        )}
        <Reveal delay={0.1} className="mt-8 border border-border bg-white p-7 md:p-8">
          <div data-testid="google-business-section" className="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
            <div className="flex items-center gap-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-border bg-white text-xl font-extrabold">
                <span className="bg-gradient-to-r from-[#4285F4] via-[#EA4335] to-[#FBBC05] bg-clip-text text-transparent">G</span>
              </span>
              <div>
                <p className="text-lg font-extrabold tracking-tight text-primary">Encuéntranos en Google</p>
                <p className="text-sm text-muted-foreground">Más reseñas, fotos y cómo llegar en nuestros perfiles de Google Business.</p>
              </div>
            </div>
            <div className="flex w-full flex-col gap-3 sm:flex-row md:w-auto">
              {locations.map((loc, i) => (
                <a
                  key={loc.id || i}
                  data-testid={`google-business-link-${i}`}
                  href={loc.maps_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex h-12 items-center justify-center gap-2 border-2 border-primary px-6 text-sm font-semibold text-primary transition-colors duration-300 hover:bg-primary hover:text-white"
                >
                  <Star className="h-4 w-4" /> {loc.name}
                </a>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
